export default {
  computed: {
    $typeAheadAboutsPolitical() {
      return [
        { value: null, text: "optional" },
        { value: "Democrat", text: "Democrat" }
      ];
    }
  }
};
